/* ==========================================================================
   Mecindo / Helsam — Artikelblokke, adfærd

   Én fil for alle interaktive blokke (17 video, 21 tjekliste, 22 behovsvælger,
   34 portionsvælger, 03 aktiv TOC) i stedet for et <script> pr. snippet.

   Alle fem blokke har en gyldig statisk tilstand uden JS (VISUEL-GUIDE §7), så
   filen tilføjer adfærd — den er aldrig en forudsætning for at blokken kan læses.
   Derfor sættes data-ab-ready først når adfærden faktisk er bundet: CSS bruger
   fraværet af det attribut til at vise fallback-tilstanden.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- 17 · Video: klik-for-at-indlæse, aldrig autoplay ---------- */

  function initVideos(root) {
    root.querySelectorAll('[data-ab-video]').forEach(function (button) {
      if (button.dataset.abReady) return;
      button.dataset.abReady = 'true';

      button.addEventListener('click', function () {
        var src = button.getAttribute('data-src');
        if (!src) return;

        var stage = button.querySelector('.ab-video__stage');
        if (!stage) return;

        var iframe = document.createElement('iframe');
        iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        iframe.setAttribute('title', button.getAttribute('aria-label') || 'Video');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        stage.innerHTML = '';
        stage.appendChild(iframe);

        // Facaden har gjort sit arbejde: erstat knappen med selve rammen, så
        // der ikke ligger en knap rundt om en iframe.
        var wrapper = button.parentNode;
        if (wrapper) wrapper.insertBefore(stage, button);
        button.remove();
      });
    });
  }

  /* ---------- 22 · Behovsvælger: præcis ét valg ad gangen ------------- */

  function initPickers(root) {
    root.querySelectorAll('[data-ab-picker]').forEach(function (picker) {
      if (picker.dataset.abReady) return;
      picker.dataset.abReady = 'true';

      var chips = picker.querySelectorAll('.ab-picker__chip');
      var panels = picker.querySelectorAll('.ab-picker__result');

      chips.forEach(function (chip, index) {
        chip.addEventListener('click', function () {
          chips.forEach(function (other, otherIndex) {
            other.setAttribute('aria-selected', otherIndex === index ? 'true' : 'false');
          });
          panels.forEach(function (panel, panelIndex) {
            panel.hidden = panelIndex !== index;
          });
        });
      });
    });
  }

  /* ---------- 34 · Portionsvælger ------------------------------------ */

  // Brøker vises som ¼ ½ ¾ (VISUEL-GUIDE §34). Alt andet rundes til én decimal,
  // og ".0" trimmes væk, så "2,0 spsk" ikke optræder.
  var FRACTIONS = { 0.25: '¼', 0.5: '½', 0.75: '¾' };

  function formatQty(value) {
    var rounded = Math.round(value * 4) / 4;
    var whole = Math.floor(rounded);
    var rest = Math.round((rounded - whole) * 100) / 100;
    var fraction = FRACTIONS[rest];

    if (fraction) return whole > 0 ? whole + fraction : fraction;
    if (rounded === whole) return String(whole);
    return String(Math.round(value * 10) / 10).replace('.', ',');
  }

  function initServings(root) {
    root.querySelectorAll('[data-ab-ingredients]').forEach(function (box) {
      if (box.dataset.abReady) return;
      box.dataset.abReady = 'true';

      var base = parseFloat(box.getAttribute('data-servings-base')) || 1;
      var current = base;
      var countEl = box.querySelector('[data-ab-servings-count]');
      var textEl = box.querySelector('[data-ab-servings-text]');
      var qtyEls = box.querySelectorAll('[data-qty-base]');

      function render() {
        if (countEl) countEl.textContent = current;
        if (textEl) textEl.textContent = current;
        qtyEls.forEach(function (el) {
          var qtyBase = parseFloat(el.getAttribute('data-qty-base'));
          if (isNaN(qtyBase)) return;
          var unit = el.getAttribute('data-unit');
          el.textContent = formatQty(qtyBase * (current / base)) + (unit ? ' ' + unit : '');
        });
      }

      box.querySelectorAll('[data-ab-servings]').forEach(function (button) {
        button.addEventListener('click', function () {
          var delta = parseInt(button.getAttribute('data-ab-servings'), 10);
          var next = current + delta;
          if (next < 1 || next > 24) return;
          current = next;
          render();
        });
      });

      render();
    });
  }

  /* ---------- 03 · Aktivt punkt i indholdsfortegnelsen --------------- */

  function initToc(root) {
    var toc = root.querySelector('[data-ab-toc]');
    if (!toc || toc.dataset.abReady) return;
    if (!('IntersectionObserver' in window)) return;
    toc.dataset.abReady = 'true';

    var links = Array.prototype.slice.call(toc.querySelectorAll('.ab-toc__link'));
    var targets = links
      .map(function (link) {
        var id = link.getAttribute('href').slice(1);
        var el = id ? document.getElementById(id) : null;
        return el ? { link: link, el: el } : null;
      })
      .filter(Boolean);

    if (!targets.length) return;

    var visible = new Set();

    function paint() {
      // Det øverste synlige afsnit er det aktive. Er intet synligt, er intet
      // aktivt — det er en gyldig tilstand (§03).
      var active = null;
      targets.forEach(function (target) {
        if (!visible.has(target.el)) return;
        if (!active || target.el.offsetTop < active.el.offsetTop) active = target;
      });
      links.forEach(function (link) {
        if (active && link === active.link) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible.add(entry.target);
          } else {
            visible.delete(entry.target);
          }
        });
        paint();
      },
      { rootMargin: '-96px 0px -60% 0px' }
    );

    targets.forEach(function (target) {
      observer.observe(target.el);
    });
  }

  /* ---------- Opstart ------------------------------------------------ */

  function init(root) {
    var scope = root || document;
    initVideos(scope);
    initPickers(scope);
    initServings(scope);
    initToc(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Shopify-temaeditoren genindlæser sektionen uden at genindlæse siden.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
